var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useEffect, useState } from 'react';
import { TagType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import { useTagContext } from '@data/tag/tagContext';
import { createDraggableId, createDroppableId, DraggableTagType, DraggableType, DroppableType, } from '@data/dragAndDrop/types';
import { TagsSidebarWrapper, TSGroupItem, TSGroupWrap, TSTable, TSTableItem } from '@styled/Sidebars';
import { FlexCol } from '@styled/FlexWrappers';
import { BasicTitle, TagBadge } from '@styled/Basic';
import { FormTextInput } from '@styled/Form';
import { TEGroupItemName } from '@styled/TagEditor';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { isTableTagJsonData } from '@data/tag/types';
import { FeatureWrapper } from '../../base/FeatureWrapper';
import { useAuth } from '../../providers/AuthProvider';
function TagsSidebar() {
    return (React.createElement(FeatureWrapper, { featureKey: "canSeeTagsSidebar" },
        React.createElement(TagsSidebarInner, null)));
}
function TagsSidebarInner() {
    var L = useLanguage().L;
    var userSettings = useAuth().settings;
    var tagData = useTagContext().tagData;
    var _a = __read(useState(''), 2), search = _a[0], setSearch = _a[1];
    var _b = __read(useState([]), 2), expanded = _b[0], setExpanded = _b[1];
    var _c = __read(useState(null), 2), activeTags = _c[0], setActiveTags = _c[1];
    var expandHandler = function (id) {
        var newExpanded = __spreadArray([], __read(expanded), false);
        if (newExpanded.includes(id)) {
            newExpanded = newExpanded.filter(function (expId) { return id !== expId; });
        }
        else {
            newExpanded.push(id);
        }
        setExpanded(newExpanded);
    };
    useEffect(function () {
        var e_1, _a;
        if (search !== '') {
            var newActiveTagsSet = tagData.searchTagsAndReturnIds(search) || new Set();
            try {
                for (var newActiveTagsSet_1 = __values(newActiveTagsSet), newActiveTagsSet_1_1 = newActiveTagsSet_1.next(); !newActiveTagsSet_1_1.done; newActiveTagsSet_1_1 = newActiveTagsSet_1.next()) {
                    var id = newActiveTagsSet_1_1.value;
                    var tag = tagData.tagById[id];
                    while (tag) {
                        newActiveTagsSet.add(tag.id);
                        tag = tagData.tagById[tag.ParentId || 0];
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (newActiveTagsSet_1_1 && !newActiveTagsSet_1_1.done && (_a = newActiveTagsSet_1.return)) _a.call(newActiveTagsSet_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (newActiveTagsSet !== activeTags) {
                setActiveTags(newActiveTagsSet);
            }
        }
        else if (activeTags !== null) {
            setActiveTags(null);
        }
    }, [search]);
    if (userSettings.show_tags_sidebar) {
        return (React.createElement(TagsSidebarWrapper, { className: "tag-sidebar" },
            React.createElement(FlexCol, { style: { padding: '15px 20px 15px 20px' } },
                React.createElement(BasicTitle, { style: { fontSize: '14px', paddingBottom: 20 } }, L('Database Objects & Properties')),
                React.createElement(FormTextInput, { autoComplete: "off", type: "text", value: search, name: "search", onChange: function (e) { return setSearch(e.target.value); }, placeholder: L('Search...'), style: { background: '#fff' } })),
            React.createElement(TSGroupWrap, null,
                React.createElement(TagGroup, { groupId: null, tagsByParentId: tagData.tagsByParentId, tagByLowercaseName: tagData.tagsByLowercase, expandHanlder: expandHandler, expanded: expanded, activeTags: activeTags }))));
    }
    else {
        return null;
    }
}
function TagGroup(_a) {
    var e_2, _b;
    var _c;
    var groupId = _a.groupId, tagsByParentId = _a.tagsByParentId, tagByLowercaseName = _a.tagByLowercaseName, expandHanlder = _a.expandHanlder, expanded = _a.expanded, activeTags = _a.activeTags, _d = _a.depth, depth = _d === void 0 ? 0 : _d;
    var L = useLanguage().L;
    var children = (_c = tagsByParentId["".concat(groupId)]) !== null && _c !== void 0 ? _c : [];
    var groups = [];
    var tables = [];
    var accounts = [];
    try {
        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var child = children_1_1.value;
            switch (child.type) {
                case TagType.Group:
                    if (activeTags === null || (activeTags === null || activeTags === void 0 ? void 0 : activeTags.has(child.id))) {
                        groups.push(child);
                    }
                    break;
                case TagType.Table:
                    if (activeTags === null || (activeTags === null || activeTags === void 0 ? void 0 : activeTags.has(child.id))) {
                        tables.push(child);
                    }
                    break;
                case TagType.Account:
                    if (activeTags === null || (activeTags === null || activeTags === void 0 ? void 0 : activeTags.has(child.id))) {
                        accounts.push(child);
                    }
                    break;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (children_1_1 && !children_1_1.done && (_b = children_1.return)) _b.call(children_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var isAccTableExpanded = expanded.includes("acc-".concat(groupId));
    var idx = 0;
    var getnNextIdx = function () {
        var nextIdx = idx;
        idx++;
        return nextIdx;
    };
    if (children.length === 0) {
        return null;
    }
    else {
        var droppableId_1 = createDroppableId({ type: DroppableType.TagSidebar, tagId: groupId });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { key: "groups-".concat(groupId), style: { paddingLeft: depth * 20 } }, groups.map(function (ch) {
                var isExpanded = expanded.includes(ch.id);
                return (React.createElement("div", { key: "group-".concat(groupId, "-").concat(ch.id) },
                    React.createElement(TSGroupItem, { onClick: function () { return expandHanlder(ch.id); } },
                        React.createElement("div", { className: "expand-btn" }, isExpanded ? React.createElement(FaChevronDown, null) : React.createElement(FaChevronRight, null)),
                        React.createElement(TEGroupItemName, { style: { paddingLeft: 0 } }, ch.name)),
                    isExpanded && (React.createElement(TagGroup, { groupId: ch.id, tagsByParentId: tagsByParentId, tagByLowercaseName: tagByLowercaseName, expandHanlder: expandHanlder, expanded: expanded, activeTags: activeTags, depth: depth + 1 }))));
            })),
            React.createElement(Droppable, { key: droppableId_1, droppableId: droppableId_1, isDropDisabled: true, isCombineEnabled: false }, function (provided) {
                return (React.createElement("div", __assign({ ref: provided.innerRef }, provided.droppableProps, { style: { paddingLeft: depth * 20 } }),
                    tables.map(function (table) {
                        var isExpanded = expanded.includes(table.id);
                        var dimensions = tagsByParentId[table.id];
                        if (activeTags !== null) {
                            dimensions = dimensions === null || dimensions === void 0 ? void 0 : dimensions.filter(function (d) {
                                return activeTags === null || activeTags === void 0 ? void 0 : activeTags.has(d.id);
                            });
                        }
                        var headers = [];
                        if (table.jsonData !== null && isTableTagJsonData(table.jsonData)) {
                            headers = table.jsonData.headers;
                        }
                        return (React.createElement(React.Fragment, { key: "fragment-".concat(groupId, "-").concat(table.id) },
                            React.createElement(DraggableTag, { key: "table-".concat(groupId, "-").concat(table.id), type: DraggableTagType.Table, tagId: table.id, tagName: table.name, idx: getnNextIdx(), sourceDroppableId: droppableId_1, isExpanded: isExpanded, expandHandler: expandHanlder }),
                            isExpanded
                                ? headers === null || headers === void 0 ? void 0 : headers.map(function (ch) {
                                    return (React.createElement(DraggableTag, { key: "property-".concat(groupId, "-").concat(table.id, "-").concat(ch.uniqueId), type: DraggableTagType.Property, tagId: table.id, tagPropertyId: ch.uniqueId, sourceDroppableId: droppableId_1, tagName: ch.name, idx: getnNextIdx() }));
                                })
                                : null,
                            isExpanded &&
                                (dimensions === null || dimensions === void 0 ? void 0 : dimensions.map(function (dimension) {
                                    return (React.createElement(DraggableTag, { key: "dim-".concat(groupId, "-").concat(table.id, "-").concat(dimension.id), type: DraggableTagType.Dimension, tagId: dimension.id, tagName: dimension.name, idx: getnNextIdx(), sourceDroppableId: droppableId_1 }));
                                }))));
                    }),
                    accounts.length > 0 && (React.createElement(DraggableTag, { key: "acctable-".concat(groupId, "-0"), type: DraggableTagType.AccountTable, tagId: groupId ? groupId : 0, tagName: L('Variables'), idx: getnNextIdx(), sourceDroppableId: droppableId_1, isExpanded: isAccTableExpanded, expandHandler: expandHanlder })),
                    isAccTableExpanded &&
                        (accounts === null || accounts === void 0 ? void 0 : accounts.map(function (acc) {
                            return (React.createElement(DraggableTag, { key: "acc-".concat(groupId, "-0-").concat(acc.id), type: DraggableTagType.Account, tagId: acc.id, tagName: acc.name, idx: getnNextIdx(), sourceDroppableId: droppableId_1 }));
                        }))));
            }),
            depth ? null : React.createElement("div", { style: { paddingTop: 4 } })));
    }
}
function getItemStyle(isDragging, draggableStyle) {
    return __assign(__assign({ userSelect: 'none' }, draggableStyle), { width: 'fit-content' });
}
function DraggableTag(_a) {
    var type = _a.type, tagId = _a.tagId, tagPropertyId = _a.tagPropertyId, tagName = _a.tagName, idx = _a.idx, sourceDroppableId = _a.sourceDroppableId, _b = _a.isExpanded, isExpanded = _b === void 0 ? false : _b, _c = _a.expandHandler, expandHandler = _c === void 0 ? function () { } : _c;
    var draggableId = createDraggableId({
        type: DraggableType.Tag,
        tagId: tagId,
        tagType: type,
        sourceDroppableId: sourceDroppableId,
        tagPropertyId: tagPropertyId,
    });
    var getComponent = function (type, isDragging) {
        switch (type) {
            case DraggableTagType.Table:
                return (React.createElement(TSTableItem, { onClick: function () { return expandHandler(tagId); } },
                    React.createElement("div", { className: "expand-btn", style: { visibility: isDragging ? 'hidden' : 'visible' } }, isExpanded ? React.createElement(FaChevronDown, null) : React.createElement(FaChevronRight, null)),
                    React.createElement(TSTable, null, tagName)));
            case DraggableTagType.AccountTable:
                return (React.createElement(TSTableItem, { onClick: function () { return expandHandler(tagId ? "acc-".concat(tagId) : "acc-null"); } },
                    React.createElement("div", { className: "expand-btn", style: { visibility: isDragging ? 'hidden' : 'visible' } }, isExpanded ? React.createElement(FaChevronDown, null) : React.createElement(FaChevronRight, null)),
                    React.createElement(TSTable, { className: "acc" }, tagName)));
            case DraggableTagType.Property:
                return (React.createElement("div", { style: { padding: '4px 0px 4px 20px', height: '32px', display: 'flex' } },
                    React.createElement(TagBadge, { className: "property" }, tagName)));
            case DraggableTagType.Dimension:
                return (React.createElement("div", { style: { padding: '4px 0px 4px 20px', height: '32px', display: 'flex' } },
                    React.createElement(TagBadge, null, tagName)));
            case DraggableTagType.Account:
                return (React.createElement("div", { style: { padding: '4px 0px 4px 20px', height: '32px', display: 'flex' } },
                    React.createElement(TagBadge, { className: "acc" }, tagName)));
        }
    };
    return (React.createElement(Draggable, { key: draggableId, draggableId: draggableId, index: idx }, function (provided, snapshot) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: getItemStyle(snapshot.isDragging, provided.draggableProps.style) }), getComponent(type, snapshot.isDragging))));
    }));
}
export default TagsSidebar;
